var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNextIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.865 5.83317C12.0393 5.83258 12.2115 5.87105 12.369 5.94575C12.5265 6.02045 12.6652 6.12948 12.775 6.26484L18.41 13.2648C18.5816 13.4736 18.6754 13.7354 18.6754 14.0057C18.6754 14.2759 18.5816 14.5378 18.41 14.7465L12.5767 21.7465C12.3786 21.9848 12.0941 22.1346 11.7856 22.163C11.4771 22.1915 11.1699 22.0962 10.9317 21.8982C10.6934 21.7001 10.5436 21.4156 10.5152 21.1071C10.4867 20.7986 10.582 20.4914 10.78 20.2532L15.995 13.9998L10.955 7.74651C10.8123 7.57526 10.7217 7.36673 10.6939 7.14559C10.666 6.92445 10.7021 6.69995 10.7978 6.49867C10.8935 6.29739 11.0449 6.12774 11.2341 6.0098C11.4232 5.89186 11.6421 5.83057 11.865 5.83317Z",
    fill: "#4A5568"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextIcon);
export default __webpack_public_path__ + "static/media/next-icon.1b2b9b3081bb9c89398dead298c78f7e.svg";
export { ForwardRef as ReactComponent };